import script from "./TabUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./TabUsers.vue?vue&type=script&setup=true&lang=js"

import "./TabUsers.vue?vue&type=style&index=0&id=07cf0dfc&lang=scss&scoped=true"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07cf0dfc"]])

export default __exports__